module.exports = __webpack_public_path__ + "img/product_65.f60ee3f.webp";